import {useRef, useState, useEffect} from "react";
import defaultBackground from '../../pics/backgrounds/happyTavern.png'
import io from 'socket.io-client';
import { backendUrl } from "../../constants";
import { formatRelativeDate } from './dateFormatter';

const sortDatesByNewest = (users, sortBy) => {
    return users.sort((a, b) => new Date(b[sortBy]) - new Date(a[sortBy]));
}

const Users = () => {
    const socketRef = useRef(null)
    const [socket, setSocket] = useState(null);
    const [users, setUsers] = useState([]);
    const [sortBy, setSortBy] = useState('last_login'); // 'last_login' or 'createddate'

    useEffect(() => {
        if (!socketRef.current) {
            socketRef.current = io(backendUrl); // Create socket connection
            setSocket(socketRef.current)
        }
    }, [socketRef]);

    useEffect(() => {
        if(socket && users.length === 0) {
            // Recieve messages from backend
            socket.emit('getUsers'); 

            socket.on('gotUsers', (users) => {
                setUsers(sortDatesByNewest(users, sortBy))
            });

        }

        // Clean up the socket connection on component unmount
        return () => { 
            if(socket) {
                socket.emit("logDisconnect", "Users Unmount")
                socket.disconnect();
            }
         };
    }, [socket]);

    useEffect(() => {
        let sorted = sortDatesByNewest(users, sortBy)
        setUsers([...sorted])
    }, [sortBy]);

    return (
        <div className="dmViewbackground" style={{backgroundImage: `url(${defaultBackground})`}}>
            <div className="firstLoadMenuContainer">
                <div className="firstLoadMenu" style={{width: "75%", height: "75%"}}>
                    <div className="userContainer">
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <h1>Users: {users?.length}</h1>
                        </div>
                        <button 
                            onClick={() => setSortBy(sortBy === 'last_login' ? 'createddate' : 'last_login')}
                            style={{padding: '0.5rem 1rem', cursor: 'pointer'}}
                        >
                            Sorted by: {sortBy === 'last_login' ? 'Last Login' : 'Created Date'}
                        </button>
                        <ol className="userGrid">
                            {users?.map((user, index) => {
                                if(user.createddate) user.createddate = user.createddate.split(' ')[0]
                                if(user.last_login) user.last_login = user.last_login.split('T')[0]

                                return (
                                    <li key={index} className="userItem">
                                        <b>{user.username}</b> 
                                        <span>
                                                {user.last_login && <span title="last login" style={{color: sortBy === "last_login" ? "#f0f0f0" : "#cecece", fontSize: sortBy === "last_login" ? "1em" : ".7em"}}>{formatRelativeDate(user.last_login)}</span>}
                                                {(user.last_login && user.createddate) && <span style={{fontSize: ".8em", color: "#cecece"}}> - </span>}
                                                {user.createddate && <span title="created date" style={{color: sortBy === "createddate" ? "#f0f0f0" : "#cecece", fontSize: sortBy === "createddate" ? ".9em" : ".7em"}}>{user.createddate}</span>}
                                        </span> 
                                    </li>
                                )
                            })}
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Users;